module.exports = __webpack_public_path__ + "img/download-inventory-big-active.9a47236c.png";